const columnNameToLabelMap: Record<string, string> = {
  accountId: 'Account',
  currency: 'Currency',
  feesDue: 'Fees Due',
  feesPaid: 'Fees Paid',
  fullNameCustomer: 'Borrower Name',
  loanAmount: 'Amount',
  principalDue: 'Principal Due',
  principalPaid: 'Principal Paid',
  product: 'Plan',
  requestedDate: 'Requested Date',
  status: 'Loan Status',
  totalDue: 'Total Due',
  totalPaid: 'Total Paid',
};

export function getColumnName(field: string): string {
  return columnNameToLabelMap[field] ?? field;
}
